<template>
  <div class="modal" v-show="show">
    <v-dialog v-model="value" persistent max-width="600px">
      <v-card>
        <v-toolbar color="blue lighten-1 " dark>
          <v-toolbar-title class="headline"
            >
           Du blir utloggad</v-toolbar-title
          >
        </v-toolbar>
        <v-card-text>
        <p>Du har varit inaktiv mer än 10 minuter och blir nu utloggad om du inte rör musen.</p>
        <p>{{ time/1000 }} sekunder kvar.</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <!-- <v-btn dark color="blue darken-1" @click="show = false">
            Ångra
          </v-btn> -->
          <!-- <v-btn color="red lighten-1" text dark @click="remove()">
            {{ Type != "Archive" ? "Ta bort" : "Arkivera" }}
          </v-btn> -->
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>


<script>

import { mapActions } from 'vuex'
export default {
  data() {
    return {
      time: 10000,
    };
  },
  name: "RemoveWindow",
  props: {
    value: {
      required: true,
    },
    As: String,
  },
    computed: {
      
    // ...mapGetters(['isIdle']),
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    ...mapActions(['SHOWSNACKBAR']),
logout_User(){
  // let temp= this;
  //  (this.As)
  if (this.As=="teacher") {
    this.logoutTeacher();
    this.setUser(null);
  }
  else if (this.As=="EHT") {
    this.logoutEHT();
    this.setUser(null);
  }
  // else
  this.logoutMappings();
  this.logoutExtras();
  this.logoutUser();
  this.logoutSchool();
this.logoutclassesAP();
this.logoutWhistles();
  //  temp.$router.replace('/login')
  this.$router.push('/')
},
    ...mapActions('teachers', ['logoutTeacher']),
    ...mapActions('ehtmembers', ['logoutEHT']),
    ...mapActions(['logoutUser','setUser']),
    ...mapActions('extra', ['logoutExtras']),
    ...mapActions('schools', ['logoutSchool']),
    ...mapActions('classesAP', ['logoutclassesAP']),
    ...mapActions('mappings', ['logoutMappings']),
    ...mapActions('whistles', ['logoutWhistles']),
  },


//   props: ['logout'],
  created() {

    let timerId = setInterval(() => {

      this.time -= 1000;
      if (!this.value) clearInterval(timerId);
      if (this.time < 1) {
        clearInterval(timerId);
        // Your logout function should be over here
        // alert("logout user....");
        this.logout_User();
      }
    }, 1000);
  },
};
</script>